import {Redirect, useParams} from "react-router";

const devices = ['android', 'ios', 'apk', 'windows', 'linux', 'mac'];

export const Installation = () => {
    let {device} = useParams<{device: string}>();

    if (!devices.includes(device)) {
        return (
            <Redirect to={{pathname: "/download"}}/>
        )
    }

    let link = '';
    if (navigator.userAgent.includes('Windows NT')) {
        link = '';
    }

    return (
        <>
            <h3>Установка для {device}</h3>

            {/*<a href={'ms-windows-store://pdp/?ProductId=telegram-desktop'}>load</a>*/}
        </>
    );
}